import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { AuthService } from "projects/sepidz-web-framework/src/lib/services";

@Component({
  selector: "callinformation",
  templateUrl: "./callinfo.component.html",
  styleUrls: ["./callinfo.component.scss"],
})
export class CallinfoComponent extends BaseFormComponent<any> {
  currentInformation = this.authService.currentInformation();

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private authService: AuthService) {
    super(selectorService, cd);
  }

  async ngOnInit() {}

  close() {
    this.closeModal();
  }
}
